// Auto-generated environment configuration for development
// DO NOT EDIT THIS FILE MANUALLY - it's generated from .env.local
// Generated on: 2026-03-24T06:36:34.645Z

window.ENV = {
  FIREBASE_API_KEY: "AIzaSyC_kanIBFqxyq8LLE4CKuzH24yEfCMjFiQ",
  FIREBASE_AUTH_DOMAIN: "meetchuthere-00.firebaseapp.com",
  FIREBASE_PROJECT_ID: "meetchuthere-00",
  FIREBASE_STORAGE_BUCKET: "meetchuthere-00.firebasestorage.app",
  FIREBASE_MESSAGING_SENDER_ID: "749689064628",
  FIREBASE_APP_ID: "1:749689064628:web:e757a95468a0a9a285dbe1",
  FIREBASE_MEASUREMENT_ID: "G-TK92730S3C",
  // Web Push VAPID key for Firebase Cloud Messaging (public)
  FIREBASE_VAPID_KEY: "BNkP6puolHFSY4nLpK65dE6yiWKHLi1d4lFrpMSM5C2qdLs-HXkq494f_S3-o2nssNMchrrSVxGRcwlWedv8-P4",
  IPINFO_TOKEN: "d951df9d159d4d",
  NODE_ENV: "development"
};

console.log('🔧 Development environment variables loaded');
